"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootAskAnAgentSagas = void 0;
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var rootAskAnAgentSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
};
exports.rootAskAnAgentSagas = rootAskAnAgentSagas;
